import { post } from '../../../infra/rest';
import requestConfig from '../../../shared/config/request';
import { AgentStatus } from '../typings';

export interface UpdateAgentStatusRequest {
  status: AgentStatus;
}

export interface UpdateAgentStatusResponse {
  success?: boolean;
  message?: string;
}

export const updateAgentStatus = async (status: AgentStatus): Promise<UpdateAgentStatusResponse> => {
  const url = `${requestConfig.aiBotBaseUrl}/v1/agent/status`;

  return post<UpdateAgentStatusResponse>(
    url,
    {
      body: JSON.stringify({ status }),
    },
    true, // isAuthRequired
    false, // isPublicApi
    true // hasFullUrl - since we're using the full aiBotBaseUrl
  );
};
